import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const AccountLayout = ({
  title = '',
  withBack = null,
  renderFilter = null,
  hasHeader = true,
  mobileChildren,
  browserChildren,
}) => {
  const history = useHistory();

  return (
    <>
      {/* mobile layout */}
      <div className="d-flex d-md-none flex-column mt-4" style={{ flex: 1, paddingBottom: '70px' }}>
        {title && (
          <div
            onClick={() => {
              if (withBack) {
                history.goBack();
              }
            }}
            role="button"
            onKeyDown={null}
            tabIndex={-1}
            className="col-12 d-flex flex-row flex-fill align-items-center h-auto text-hover">
            {withBack && (
              <i
                className="icon-arrow-back-navigation ps-3 text-f4 me-2 cursor-pointer"
                aria-label="Back"
                style={{ width: '1rem' }}
              />
            )}
            <span className="text-center w-100" style={{ marginLeft: '-1.5rem' }}>
              <b>{title}</b>
            </span>
          </div>
        )}
        {renderFilter && <div className="col-md-9 col-sm-12">{renderFilter && renderFilter()}</div>}
        {mobileChildren}
      </div>

      {/* browser layout */}
      <div className="d-none d-md-block container-xl">
        {hasHeader && (
          <>
            <div className="row mt-4 mb-4">
              {title && (
                <div
                  onClick={() => {
                    if (withBack) {
                      history.goBack();
                    }
                  }}
                  role="button"
                  onKeyDown={null}
                  tabIndex={-1}
                  className="col-md-3 col-sm-12 d-flex flex-row flex-fill align-items-center h-auto text-hover">
                  {withBack && (
                    <i
                      className="icon-arrow-back-navigation text-f4 me-2 cursor-pointer"
                      aria-label="Back"
                      style={{ width: '1rem' }}
                    />
                  )}
                  <span>
                    <b>{title}</b>
                  </span>
                </div>
              )}
              {renderFilter && (
                <div className="col-md-9 col-sm-12 px-0">{renderFilter && renderFilter()}</div>
              )}
            </div>
          </>
        )}
        <div className={`row ${hasHeader ? '' : 'mt-5'}`}>{browserChildren}</div>
      </div>
    </>
  );
};

export default AccountLayout;

AccountLayout.propTypes = {
  mobileChildren: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  browserChildren: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  title: PropTypes.string,
  withBack: PropTypes.bool,
  renderFilter: PropTypes.func,
  hasHeader: PropTypes.bool,
};
AccountLayout.defaultProps = {
  title: '',
  withBack: null,
  renderFilter: null,
  hasHeader: true,
};
